<template>
    <div class="max-w-sm mx-auto px-6">
        <div class="flex items-center justify-center h-64">
            <div class="text-center">
                <span class="icon text-5xl text-grey"><i class="mdi mdi-loading mdi-spin"></i></span><br />
                <span class="text-sm text-grey-darker mt-4" v-text="$t('Loading')"></span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'loading-block'
    }
</script>


// WEBPACK FOOTER //
// src/components/Patient/LoadingBlock.vue